import { Injectable } from '@angular/core';
import { NotificationRef, NotificationService, NotificationSettings } from '@progress/kendo-angular-notification';
import { ExtendedNotificationSettings } from '../models/extended-notification-settings';

@Injectable()
export class ExtendedNotificationService extends NotificationService {
    protected openNotificationArray: NotificationRef[] = [];

    override show(settings: ExtendedNotificationSettings): NotificationRef {
        const notificationRef = super.show(settings);

        notificationRef.afterHide?.subscribe(() => {
            this.openNotificationArray.splice(this.openNotificationArray.indexOf(notificationRef), 1);
        });

        if (!settings.stayVisibleOnRouteChange) {
            this.openNotificationArray.push(notificationRef);
        }

        return notificationRef;
    }

    public removeAllNotifications() {
        this.openNotificationArray.forEach(notificationRef => {
            notificationRef.hide();
        });
    }
}